import { useState } from "react";
import { fitmentData } from "../data/fitmentData";

import { useVehicle } from "../context/VehicleContext";

function ModelSelectorModal({
  diagramMode = true,
  modelSelectorOpen,
  setModelSelectorOpen,
  selectedYear,
  setSelectedYear,
  selectedMake,
  setSelectedMake,
  selectedModel,
  setSelectedModel,
  selectedSystem,
  setSelectedSystem,
  selectedSubSystem,          
  setSelectedSubSystem,
  makes,
  models,
  years
}) {

const [yearMenuOpen, setYearMenuOpen] = useState(false);
const [makeMenuOpen, setMakeMenuOpen] = useState(false);
const [modelMenuOpen, setModelMenuOpen] = useState(false);
const { setSelectedVehicle } =
  useVehicle();


const systems = [
  "Engine",
  "Intake",
  "Exhaust",
  "Electrical",
  "Fuel",
  "Hull",
  "Oil",
  "JetPump",
  "Reverse",
  "Steering",
  "Graphics",
  "Seat"
];


const subSystemsMap = {
  Engine: [
    "Cylinder Head",
    "Crankcase",
    "Crankshaft / Pistons",
    "Valvetrain",
    "Gaskets",
    "Motor Mounts"
  ],

  Electrical: [
    "Main",
    "Ignition",
    "Charging"
  ],


  Oil: [
    "Oil Pump",
    "Oil Cooler",
    "Oil Pan"
  ],

  
 Hull: [
    "Body",
    "Gunwale Mat",
    "Intake Grate / Plate",
    "Fittings / Sponsons",
    "Side Covers",
    "Front Cover / Hood",
    "Ventilation"
  ]


};



if (!modelSelectorOpen) return null;

return (

<div style={styles.modalOverlay}>

<div style={styles.modal}>

<div
style={styles.closeButton}
onClick={() => setModelSelectorOpen(false)}
onMouseEnter={(e)=>{
  e.currentTarget.style.background="#F2F4FF";
}}
onMouseLeave={(e)=>{
  e.currentTarget.style.background="transparent";
}}
>
✕
</div>

<div style={styles.modalTitle}>
Select Year / Make / Model
</div>

<div style={styles.selectorRow}>

{/* YEAR SELECTOR */}
<div style={styles.selectorContainer}>

<div
style={styles.selectorPill}
onClick={()=>{
  setYearMenuOpen(!yearMenuOpen);
  setMakeMenuOpen(false);
  setModelMenuOpen(false);
}}
>
{selectedYear || "Year"} ▾
</div>

{yearMenuOpen && (
<div style={styles.dropdown}>

{years.map((year)=>(
<div
key={year}
style={styles.dropdownItem}

onMouseEnter={(e)=>{
e.currentTarget.style.background="#F5F7FF";
}}

onMouseLeave={(e)=>{
e.currentTarget.style.background="transparent";
}}

onClick={()=>{
setSelectedYear(year);
setYearMenuOpen(false);
}}
>
{year}
</div>
))}

</div>
)}

</div>


{/* MAKE SELECTOR */}
<div style={styles.selectorContainer}>

<div
style={styles.selectorPill}
onClick={()=>{
setMakeMenuOpen(!makeMenuOpen);
setYearMenuOpen(false);
setModelMenuOpen(false);
}}
>
{selectedMake || "Make"} ▾
</div>

{makeMenuOpen && (
<div style={styles.dropdown}>

{makes.map((make)=>(
<div
key={make}
style={styles.dropdownItem}

onMouseEnter={(e)=>{
e.currentTarget.style.background="#F5F7FF";
}}

onMouseLeave={(e)=>{
e.currentTarget.style.background="transparent";
}}

onClick={()=>{
setSelectedMake(make);
setSelectedModel(null);
setMakeMenuOpen(false);
}}
>
{make}
</div>
))}

</div>
)}

</div>


{/* MODEL SELECTOR */}
<div style={styles.selectorContainer}>

<div
style={{
...styles.selectorPill,
opacity: selectedMake ? 1 : 0.5,
cursor: selectedMake ? "pointer" : "not-allowed"
}}

onClick={()=>{
if(!selectedMake) return;

setModelMenuOpen(!modelMenuOpen);
setYearMenuOpen(false);
setMakeMenuOpen(false);
}}
>
{selectedModel || "Model"} ▾
</div>

{modelMenuOpen && selectedMake && (

<div style={styles.dropdown}>

{(selectedYear && fitmentData[selectedMake]?.[selectedYear]
  ? fitmentData[selectedMake][selectedYear]
  : models[selectedMake]
).map((model)=>(



<div
key={model}
style={styles.dropdownItem}

onMouseEnter={(e)=>{
e.currentTarget.style.background="#F5F7FF";
}}

onMouseLeave={(e)=>{
e.currentTarget.style.background="transparent";
}}

onClick={()=>{
setSelectedModel(model);
setModelMenuOpen(false);
}}
>
{model}
</div>
))}

</div>

)}

</div>

</div>

{diagramMode && (

<div style={styles.systemSection}>

<div style={styles.systemTitle}>
Select System
</div>

<div style={styles.systemGrid}>

{systems.map(system => (

<div
key={system}
style={{
...styles.systemCard,
opacity: selectedModel ? 1 : 0.45,
pointerEvents: selectedModel ? "auto" : "none",
background: selectedSystem === system ? "#EEF2FF" : "rgba(255,255,255,0.95)",
border: selectedSystem === system ? "1px solid #2563EB" : "1px solid rgba(0,0,0,0.05)"
}}
onMouseEnter={(e)=>{
e.currentTarget.style.transform =
  "translateY(-4px) scale(1.03)";

e.currentTarget.style.boxShadow =
`
  inset 0 1px 0 rgba(255,255,255,0.9),
  0 12px 30px rgba(0,0,0,0.06),
  0 30px 60px rgba(0,0,0,0.05)
`;
}}

onMouseLeave={(e)=>{
e.currentTarget.style.transform="translateY(0)";
e.currentTarget.style.boxShadow="0 6px 14px rgba(0,0,0,0.08)";
}}

onClick={() => {
  if (!selectedModel) return;

  const hasSubSystems = subSystemsMap[system];

  setSelectedSystem(system);

  if (!hasSubSystems) {
    // 🚀 No subsystems → open immediately
    setSelectedSubSystem(null);
    setModelSelectorOpen(false);
  } else {
    // show subsystem grid
    setSelectedSubSystem(null);
  }
}}
>

{system}

</div>




))}

</div>



  {/* 🔥 STEP 2 GOES RIGHT HERE */}
  {selectedSystem && (
    <div style={{ marginTop: 20 }}>
      
      <div style={styles.systemTitle}>
        Select Sub-System
      </div>

      <div style={styles.systemGrid}>
        {subSystemsMap[selectedSystem]?.map(sub => (
          <div
            key={sub}
            style={styles.systemCard}
            onClick={() => {
              setSelectedSubSystem(sub);
              setModelSelectorOpen(false);
            }}
          >
            {sub}
          </div>
        ))}
      </div>

    </div>
  )}


</div>

)}

<button
style={styles.loadButton}
onClick={() => {

  setSelectedVehicle({
    year: selectedYear,
    manufacturer: selectedMake,
    model: selectedModel,
  });

  setModelSelectorOpen(false);

}}

>
{diagramMode
  ? "Load Diagram"
  : "Save Vehicle"}
</button>

</div>

</div>

)

}

export default ModelSelectorModal


const styles = {

modalOverlay:{
position:"fixed",
top:0,
left:0,
right:0,
bottom:0,
background:"rgba(0,0,0,0.35)",
display:"flex",
alignItems:"center",
justifyContent:"center",
zIndex:1000
},

modal:{
  position:"relative",
  width:"calc(100% - 32px)",  /* 16px gap each side on mobile */
  maxWidth:520, 
background:"rgba(255,255,255,0.94)",
backdropFilter:"blur(14px)",
borderRadius:20,
padding:32,
boxShadow:"0 40px 90px rgba(0,0,0,0.22)"
},




modalTitle:{
fontSize:20,
fontWeight:600,
marginBottom:20
},

selectorRow:{
display:"flex",
gap:12,
marginBottom:20
},

selectorContainer:{
position:"relative",
flex:1
},

selectorPill:{
flex:1,
display:"flex",
alignItems:"center",
justifyContent:"space-between",
padding:"12px 16px",
borderRadius:16,
background:"rgba(255,255,255,0.85)",
border:"1px solid rgba(0,0,0,0.06)",
fontSize:14,
fontWeight:500,
cursor:"pointer",
boxShadow:
"0 6px 14px rgba(0,0,0,0.08), \
 inset 0 1px 0 rgba(255,255,255,0.8)",
transition:"all .18s ease"
},

dropdown:{
position:"absolute",
top:50,
left:0,
right:0,
background:"#fff",
borderRadius:14,
boxShadow:"0 12px 28px rgba(0,0,0,0.18)",
overflow:"auto",
maxHeight:240,
zIndex:50
},

dropdownItem:{
padding:"10px 14px",
cursor:"pointer",
fontSize:14,
transition:"background .15s ease"
},

loadButton:{
marginTop:32,
alignSelf:"center",

padding:"12px 26px",

borderRadius:16,
border:"none",

background:"#2563EB",
color:"#fff",

fontWeight:600,
fontSize:15,

cursor:"pointer",

boxShadow:"0 8px 18px rgba(37,99,235,0.35)"
},



closeButton:{
position:"absolute",
top:14,
right:14,
width:32,
height:32,
display:"flex",
alignItems:"center",
justifyContent:"center",
borderRadius:10,
fontSize:16,
fontWeight:600,
cursor:"pointer",
transition:"background .15s ease"
},



systemSection:{
marginTop:24
},

systemTitle:{
fontSize:16,
fontWeight:600,
marginBottom:14,
color:"#1D1D1F"
},

systemGrid:{
display:"grid",
gridTemplateColumns:"repeat(3,1fr)",
gap:12
},

systemCard:{

minHeight: 54,

padding:"0 20px",

borderRadius:999,

background:
  "rgba(255,255,255,0.42)",

backdropFilter:"blur(24px)",
WebkitBackdropFilter:"blur(24px)",

border:
  "1px solid rgba(255,255,255,0.55)",

display:"flex",
alignItems:"center",
justifyContent:"center",

color:"#111111",

fontSize:12,
fontWeight:700,
letterSpacing:"1.4px",

textTransform:"uppercase",

textAlign:"center",

cursor:"pointer",

boxShadow:
`
  inset 0 1px 0 rgba(255,255,255,0.9),
  0 6px 20px rgba(0,0,0,0.04),
  0 20px 40px rgba(0,0,0,0.03)
`,

transform:"translateZ(0)",

transition:"all .22s ease",
},



}